import { ITrajektRefBreak } from '../interfaces/pitches';
import {
  IAcceleration,
  IPosition,
  IVelocity,
} from '../interfaces/pitches/i-base';
import { FT_TO_INCHES, GRAVITY_FT_PER_SEC } from './math.utilities';

interface IVeloAccel {
  velo: IVelocity;
  accel: IAcceleration;
}

interface IInitial {
  // in FT
  pos: IPosition;
  // in FTPS
  velo: IVelocity;
}

interface IFinal {
  // in FT
  pos: IPosition;
  time: number;
}

export class BreakHelper {
  static getVeloAccel(config: {
    initial: IInitial;
    final: IFinal;
    breaks: ITrajektRefBreak;
  }): IVeloAccel {
    const { initial, final, breaks } = config;

    const timeSq = Math.pow(final.time, 2);

    // this function gets the necessary velocity and acceleration to preserve
    // the plate location and break in a 9P traj
    const vx =
      ((breaks.xInches / FT_TO_INCHES - final.pos.px + initial.pos.px) /
        (initial.pos.py - final.pos.py)) *
      initial.velo.vy;

    const vz =
      ((breaks.zInches / FT_TO_INCHES -
        final.pos.pz +
        initial.pos.pz -
        0.5 * GRAVITY_FT_PER_SEC * timeSq) /
        -(initial.pos.py - final.pos.py)) *
      Math.sqrt(Math.pow(vx, 2) + Math.pow(initial.velo.vy, 2));

    return {
      velo: {
        vx: vx,
        vy: initial.velo.vy,
        vz: vz,
      },

      accel: {
        ax: (2 * (final.pos.px - initial.pos.px - vx * final.time)) / timeSq,
        ay:
          (2 * (final.pos.py - initial.pos.py - initial.velo.vy * final.time)) /
          timeSq,
        az: (2 * (final.pos.pz - initial.pos.pz - vz * final.time)) / timeSq,
      },
    };
  }
  static getBreaks(config: {
    initial: IInitial;
    final: IFinal;
  }): ITrajektRefBreak {
    // Univeral break calculation using the MLB formula
    const { initial, final } = config;

    // final minus initial
    const delta: IPosition = {
      px: final.pos.px - initial.pos.px,
      py: final.pos.py - initial.pos.py,
      pz: final.pos.pz - initial.pos.pz,
    };

    const xFt = delta.px - delta.py * (initial.velo.vx / initial.velo.vy);
    const zFt =
      delta.pz +
      delta.py *
        (initial.velo.vz /
          Math.sqrt(
            Math.pow(initial.velo.vx, 2) + Math.pow(initial.velo.vy, 2)
          )) +
      0.5 * GRAVITY_FT_PER_SEC * Math.pow(final.time, 2);

    return {
      xInches: xFt * FT_TO_INCHES,
      zInches: zFt * FT_TO_INCHES,
    };
  }
}
